<template>
  <div>
    <modal-header
        :title="title"
        @close="close"
        @search="search"
        ref="modalHeader"
    ></modal-header>
    <div class="add-box clearfix">
      <vxe-table
          show-overflow
          highlight-hover-row
          stripe
          border="none"
          ref="xTable"
          class="table-style"
          :max-height="accountCate == 'platform' ? 530 : 500"
          align="center"
          auto-resize
          :data="tableData"
          @cell-click="cellClick"
      >
<!--        <vxe-table-column field="companyName" title="企业名称" v-if="accountCate == 'platform'"></vxe-table-column>-->
        <vxe-table-column field="accountName" title="账户名称"></vxe-table-column>
        <vxe-table-column field="bankName" title="开户行" v-if="accountCate == 'platform'"></vxe-table-column>
        <vxe-table-column field="openBankName" title="开户行" v-if="accountCate == 'user'"></vxe-table-column>
        <vxe-table-column field="accountNum" title="银行账号"></vxe-table-column>
        <vxe-table-column field="bankAccountType" title="账户类型" v-if="accountCate == 'platform'">
          <template v-slot="{ row }">
            <div>{{ row.bankAccountType === 1 ? "现金账户" : "银行账户" }}</div>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page.currentPage"
          :page-size.sync="page.pageSize"
          :total="page.totalResult"
          @page-change="getBankAccountList"
          v-if="accountCate == 'user'"
      ></vxe-pager>
    </div>
  </div>
</template>
<script>
  import {apiRequest} from "@/utils/api";
  import ModalHeader from "@/components/common/ModalHeader";

  const empties = [undefined, "", null, "null", {}, []];

  export default {
    name: "BankAccount",
    components: {
      ModalHeader,
    },
    data() {
      return {
        accountCate: "",
        accountName: "",
        accountNum: "",
        title: "",
        tableData: [],
        page: {
          currentPage: 1,
          pageSize: 10,
          totalResult: 100,
        },
        field: "",
        obj: null,
        orderType: null,
        ownSearch: false
      };
    },
    methods: {
      init(accountCate, field, obj) {
        this.ownSearch = false;
        this.accountCate = accountCate;
        this.title =
          accountCate == "platform" ? "选择平台银行账户" : "选择用户银行账户";
        this.page.currentPage = 1;
        this.accountName = "";
        this.accountNum = "";
        // console.log(accountCate, field, obj);
        // debugger
        this.field = field;
        this.obj = obj;
        // console.log(this.obj, '123');
        // debugger
        this.orderType = obj ? obj.paymentType : '';

        this.$refs.modalHeader.clear();
        this.getBankAccountList();
      },
      search(word, accountWord) {
        this.ownSearch = true;
        this.page.currentPage = 1;
        this.accountName = word;
        this.accountNum = accountWord;
        this.getBankAccountList();
      },
      async searchByUserId(id) {
        this.accountName = null;
        let params = {
          page: this.page.currentPage,
          rows: this.page.pageSize,
          userType: 0,
          userId: id
        };
        let res = await apiRequest(
          "api/auth/",
          "baseUserSign/queryUserBankList",
          params
        );
        this.tableData = res.data.rows;
        this.page.totalResult = res.data.total;
      },
      async getBankAccountList() {
        let params = {
          page: this.page.currentPage,
          rows: this.page.pageSize,
          userType: 0,
        };
        if (!empties.includes(this.accountName)) {
          params.accountName = this.accountName;
        }
        if (!empties.includes(this.accountNum)) {
          params.accountNum = this.accountNum;
        }
        let res;
        if (this.accountCate === "platform") {
          // 平台企业
          if (this.field === 'recName' && !this.ownSearch) {
            params.accountName = this.obj ? this.obj.compName : '';
          }
          // else {
          //   params.accountName = null;
          // }

          res = await apiRequest("api/order/", "platform_corp/getPlatformCompanyList", params);
          this.tableData = res.data.rows;
        } else {
          if (this.field === 'paymentsName' && !this.ownSearch) {
            params.userId = this.obj.clientId;
          } else {
            params.userId = null;
          }

          res = await apiRequest("api/auth/", "baseUserSign/queryUserBankList", params);
          this.tableData = res.data.rows;
          this.page.totalResult = res.data.total;
        }
        console.log(this.tableData);
      },
      cellClick({row}) {
        this.$emit("choose", row);
      },
      close() {
        this.$emit("close");
      },
    },
  };
</script>